import { __assign } from "tslib";
import _ from 'lodash';
export var mergeResponse = function (channel, youtube) { return (__assign(__assign({}, channel), _.omit(youtube, 'id', 'title', 'description'))); };
